<template>
	<div id="sales-performance">
		<div class="sales-performance-container">
			<div v-if="!serverComplete" id="performance-loading">
				<span class="loading-icon"></span>
				<span class="loading-message">{{ busyText }}</span>
			</div>
			<h2>Cashier Sales Report</h2>
			<div class="all-statuses-switch">
				<label class="switch">
					<input type="checkbox" v-model="includeDeletedCashiers" id="includeDeletedCashiersSwitch">
					<span class="slider round"></span>
				</label>
				<p>Show Deleted Cashiers</p>
			</div>
			<div style="display: flex; justify-content: center;">
				<p><span style="color: red;">*</span> Means that this is not available in your jurisdiction</p>
			</div>
			<FilterDateTime :dateDefaults="dateDefaults" :showExportButton="showExportButton" />
			<div style="display: flex; justify-content: center;">
				<label for="casinoOptions" v-if="casinoListForReports.length > 1">Casino</label>
				<select title="Select Casino" id="casinoOptions" v-model="selectedCasinoId" v-if="casinoListForReports.length > 1">
					<option v-for="(casino, index) in casinoListForReports" :key="index" :value="casino.id">{{ casino.name }}</option>
				</select>
			</div>
			<div v-if="cashierSalesReports.length > 0">
				<div>
					<CashierSalesReportTable 
						:inGameCurrencyTool="inGameCurrencyTool"
						:systemCurrencyTool="systemCurrencyTool"
						:systemSettings="systemSettings"
						:isMobile="isMobile"
						:cashierSalesReports="cashierSalesReports"
						:totals="totals"
					/>
				</div>
			</div>
			<h2 v-else>Cashier Sales Report not available.</h2>
		</div>
	</div>
</template>

<script>
import { onBeforeUnmount, toHandlerKey } from "vue";
import sharedScripts from "@/dependencies/sharedScripts";
import xlsxSalesStyles from "@/dependencies/xlsxSalesStyles";
import FilterDateTime from "@/components/FilterDateTime";
import CashierSalesReportTable from "@/components/CashierSalesReportTable";
import xlsxPerformStyles from "@/dependencies/xlsxPerformStyles";

export default {
	name: "CashierSalesReport",
	components: {
		FilterDateTime,
		CashierSalesReportTable,

	},
	props: {
		reporterState: Object,
		casinoList: Array,
		isMobile: Boolean,
		serverVersion: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		systemSettings: Object,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
            serverComplete: true,
			dateDefaults: {},
			showExportButton: true,
			casinoListForReports:[],
			selectedCasinoId: this.reporterState.casinoId,
			startDate: this.getLastArchiveWeekRange(true).start,
			endDate: this.getLastArchiveWeekRange(true).end,
			includeDeletedCashiers: false,
			cashierSalesReports:[],
			totals: {
				cashInTotal: 0,
				cashOutTotal: 0,
				sumTotalHolds: 0,
				cashInCountTotal: 0,
				cashOutCountTotal: 0,
				totalHold: {
					value: 0,
					sign: true,
				},
			},
			excelStart: 0,
			excelEnd:  0,
			fileNameDateRange: `${this.startDate}_to_${this.endDate}`,
			dateFmt: "[$-409]m/d/yy\ h:mm\ AM/PM;@",
			currFmt: `"$"#,##0.00_);[Red]\("$"#,##0.00\)`,
			filters: null,
			selectedCasino: null,
		};
	},
	watch: {
		includeDeletedCashiers() {
			this.getCashierSalesReport();
		},
		selectedCasinoId(){
			this.getSelectedCasino()
			this.getCashierSalesReport();
		}
	},
	created() {
		this.listCasinosForThisReporter();
		this.getSelectedCasino();
		// let end = new Date();
		// end = end.setHours(end.getHours() - this.timeZoneOffset);
		// end = new Date(end).toISOString();
		this.dateDefaults = {
			startDate: this.startDate,
			endDate: this.endDate,
		};
		this.eventBus.on("applyFilters", (payload) => {

			let startDateCheck = new Date(payload.startDate).getFullYear();
			let endDateCheck =   new Date(payload.endDate).getFullYear();

			if(startDateCheck < 1970 || startDateCheck > endDateCheck || startDateCheck > 2126 || startDateCheck.toString().length > 4 || !startDateCheck) {
				this.status.ok = false;
				this.status.message = "Please enter a valid start date";
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(endDateCheck < 1970 ||  endDateCheck < startDateCheck || endDateCheck > 2126 || endDateCheck.toString().length > 4 || !endDateCheck) {
				this.status.ok = false;
				this.status.message = "Please enter a valid end date";
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(payload.startDate > payload.endDate) {
				this.status.message = "Start date cannot be after end date";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			this.applyFilters(payload);
			let error = false;
			if (!payload.startDate) {
				this.throwDateTimeError("Start Date");
				error = true;
			}
			if (!payload.endDate) {
				this.throwDateTimeError("End Date");
				error = true;
			}
			if (error) return;

			let dayLightSavingsTime = false;
    		let currYear = new Date().getFullYear();
			let secondSundayOfMarch = new Date(currYear,2,7);
			secondSundayOfMarch.setDate(7 +(7- secondSundayOfMarch.getDay()));

			let novemberForDateObejct = 10;
			let firstSundayOfNovember = this.firstSunday(novemberForDateObejct,currYear);
			let today = new Date();
			if(today > secondSundayOfMarch && today < firstSundayOfNovember) dayLightSavingsTime = true;
			if(dayLightSavingsTime){
				//let oneHour = new Date(payload.endDate).getTime() + (60* 60000);
				payload.startDate = new Date(payload.startDate).toISOString();
				payload.endDate = new Date(payload.endDate).toISOString();
			} else{
				payload.startDate = new Date(payload.startDate).toISOString();
				payload.endDate = new Date(payload.endDate).toISOString();
			}
			;
			this.startDate = payload.startDate ? payload.startDate.slice(0, 16) : "";
			this.endDate = payload.endDate ? payload.endDate.slice(0, 16) : "";
			this.getCashierSalesReport();
		});
		this.eventBus.on("exportExcel", () =>{
			this.exportExcel();
		});
		this.getCashierSalesReport();
	},
	methods: {
		firstSunday(month,year){
			let tempDate = new Date();
    		tempDate.setMonth(month);
    		tempDate.setYear(year);
    		tempDate.setDate(1);

    		let day = tempDate.getDay();
    		let toNextSun = day !== 0 ? 7 - day : 0;
    		tempDate.setDate(tempDate.getDate() + toNextSun);
    
    		return tempDate;
		},
		getSelectedCasino() {
			this.casinoListForReports.forEach((casino) =>{
				if(casino.id == this.selectedCasinoId){
					this.selectedCasino = casino;
				}
			});
		},
		applyFilters(filters){

			this.filters = filters;
			this.fileNameDateRange = `${this.filters.startDate}_to_${filters.endDate}`;
			this.excelStart = this.isoDateToExcelDate(this.filters.startDate,false, true);
			this.excelEnd = this.isoDateToExcelDate(this.filters.endDate,false, true);
		},
		listCasinosForThisReporter() {
			if (!this.reporterState?.isSysadmin) {
				let permissionsList = this.reporterState?.userPermissions?.sitePermissions;
				for (const key in permissionsList) {
					if (permissionsList[key].includes("SiteAdmin") || permissionsList[key].includes("Reporter")) {
						let casino = this.casinoList.filter((casino) => casino.id == key)[0];
						this.casinoListForReports.push(casino);
					}
				}
			} else {
				this.casinoListForReports = this.casinoList;
			}
		},

		resetAllTotals() {
			this.totals = {
				cashInTotal: 0,
				cashOutTotal: 0,
				sumTotalHolds: 0,
				cashInCountTotal: 0,
				cashOutCountTotal: 0,
				totalHold: {
					value: 0,
					sign: true,
				},
			};
		},
		async getCashierSalesReport() {
			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				return false;
			}

			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.reporterState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let requestUrl = new URL("/api/v1/report/cashier/timerangesales", this.rabbitsfootHostUrl);
			let params = requestUrl.searchParams;

			params.set("casinoId", this.selectedCasinoId);
			params.set("startDate", this.startDate);
			params.set("endDate", this.endDate);
			params.set("includeDeletedCashiers" , this.includeDeletedCashiers);

			requestUrl.search = params.toString();

			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverComplete = true;
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.code === 409) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();
				this.cashierSalesReports = dataJson.rows;
				this.resetAllTotals();
				this.setSalesReportTotals();

				this.serverComplete = true;
				this.busyText = "";
			} catch (e) {
				this.serverComplete = true;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = e;
				console.error(e);
			}
		},

		setSalesReportTotals() {
			if (this.cashierSalesReports.length > 0) {
				this.cashierSalesReports.forEach((item) => {
					this.totals.cashInTotal += item.cashInValueCOC;
					this.totals.cashOutTotal += item.cashOutValueCOC;
					this.totals.cashInCountTotal += item.cashInCount;
					this.totals.cashOutCountTotal += item.cashOutCount;
					item.totalHold = this.calculateTotalHolds(item);
					this.totals.sumTotalHolds += item.totalHold.value;
				});
			}
		},
		calculateTotalHolds(item) {
			let cashIns = item.cashInValueCOC;
			let cashOuts= item.cashOutValueCOC;
			let holdTotal = cashIns - cashOuts;
			
			let hold = {
				value: holdTotal,
				sign: true,
			};
			hold.sign = Math.sign(hold.value) !== -1; // check if negative number

			return hold;
		},
		async exportExcel() {
			if (this.cashierSalesReports.length === 0) {
				this.status.message = "Nothing to export";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}

			const workbook = new this.ExcelJS.Workbook();
			workbook.creator = "Reporter App";
			workbook.lastModifiedBy = "Reporter App";
			workbook.created = new Date();
			workbook.modified = new Date();
			this.fileNameDateRange = `${this.startDate}_to_${this.endDate}`;
			if (!this.filters) {
				let filters = {
					startDate: this.startDate ? this.startDate : null,
					endDate: this.endDate ? this.endDate : null,
				};
				this.filters = filters;
				this.eventBus.emit("applyFilters", this.filters);
			}
			let contextRows = [
				[this.selectedCasino.name],
				["Cashier Sales Report"],
				[this.serverVersion.serverName],
				["From:", this.excelStart],
				["To:", this.excelEnd]];
			
			//The superHeaders are the main headers that cover the top for the different sections like Web and Cashier
			let superHeader = ["Name", "", "Cash In", "", "Cash Out","", "Total"];
			

			// header row
			const worksheet = workbook.addWorksheet("Cashier Sales Report", {
				// freeze header rows (the + 1 is for row getting added at next insertRows)
				//views: [{ state: "frozen", xSplit: 2, ySplit: contextRows.length + 2 }],
			});

			//This changes the row after the superheader
			worksheet.columns = [
				{ header: "Full Name", key: "fullName", width: 50 },
				{ header: "Cashier Name", key: "cashierName", width: 35 },
				{ header: "Cash In Count", key: "cashInCount", width: 30 },
				{ header: "Cash In Value COC", key: "cashInValueCOC", width: 30 },
				{ header: "Cash Out Count", key: "cashOutCount", width: 30 },
				{ header: "Cash Out Value COC", key: "cashOutValueCOC", width: 30 },
				{ header: "Total", key: "total", width: 30 },
			]
			
			worksheet.insertRows(1, contextRows);
			worksheet.mergeCells("A1:B1");
			worksheet.mergeCells("A2:B2");

			//This sets the format for the cell or column like dateFmt sets the cell for date format
			worksheet.getCell("B3").numFmt = this.dateFmt;
			worksheet.getCell("B4").numFmt = this.dateFmt;
			
			worksheet.eachRow(function (row, rowNumber) {
				row.font = xlsxPerformStyles.defaultStyles.font;
			});
			
			worksheet.getColumn("cashInValueCOC").numFmt = this.currFmt;
			worksheet.getColumn("cashOutValueCOC").numFmt = this.currFmt;
			worksheet.getColumn("total").numFmt = this.currFmt;

			worksheet.eachRow(function (row, rowNumber) {
				row.font = xlsxSalesStyles.defaultStyles.font;
				row.alignment = { horizontal: "left" };
			});

			// set row offset before adding, merging, and styling superHeader row
			let rowOffset = worksheet.rowCount;
			worksheet.insertRow(rowOffset, superHeader);
			this.setStylesForCells(worksheet, xlsxSalesStyles.headerStyles, rowOffset);
			worksheet.getCell(`A${rowOffset}`).fill = xlsxSalesStyles.casinoCell;
			worksheet.getCell(`C${rowOffset}`).fill = xlsxSalesStyles.cashierCell;
			worksheet.getCell(`E${rowOffset}`).fill = xlsxSalesStyles.webcell;
			worksheet.getCell(`G${rowOffset}`).fill = xlsxSalesStyles.totalsCell;
			
			
			// This allows for the rows for the superheader to take up as many rows as the range covers
			//i.e the line below the first superheader will cover A and B columns
			worksheet.mergeCells(`A${rowOffset}:B${rowOffset}`);
			worksheet.mergeCells(`C${rowOffset}:D${rowOffset}`);
			worksheet.mergeCells(`E${rowOffset}:F${rowOffset}`);
			

			// set row offset before adding styling to header
			rowOffset = worksheet.rowCount;
			let headerOffset = rowOffset + 1;
			this.setStylesForCells(worksheet, xlsxSalesStyles.headerStyles, rowOffset);

			this.cashierSalesReports.forEach((item, index) => {
				// need unique copy of sales report to keep from mutating the prop that's passed to child component
				let data = Object.assign({}, item);

				if(data.nameFirst == null && data.nameLast == null && data.nameLast2 == null)data.fullName = "N/A"
				else data.fullName = data.nameFirst + " " + data.nameLast + " "+  data.nameLast2;
				
				data.cashierName = data.displayName;
				data.total = data.totalHold.value;

				worksheet.addRow(data);

				rowOffset = worksheet.rowCount;

				this.setStylesForCells(worksheet, xlsxSalesStyles.basicStyles, rowOffset);
				worksheet.getCell(`B${rowOffset}`).alignment = xlsxSalesStyles.left;

				// Fill every even numbered row after header row.
				// Rows are not zero indexed so we actually are selecting for odd since we want the even rows AFTER header
				if (index % 2 !== 0) this.setSingleStyleForCells(worksheet, "fill", xlsxSalesStyles.oddFill, rowOffset);
			});

			// set row offset before inserting Totals row
			rowOffset = worksheet.rowCount + 1;
			worksheet.insertRow(rowOffset, ["Total"]);
			worksheet.mergeCells(`A${rowOffset}:B${rowOffset}`);
			worksheet.getCell(`A${rowOffset}`).alignment = xlsxSalesStyles.center;
			worksheet.getCell(`C${rowOffset}`).value = { formula: `SUM(C${headerOffset}:C${rowOffset - 1})` };
			worksheet.getCell(`D${rowOffset}`).value = { formula: `SUM(D${headerOffset}:D${rowOffset - 1})` };
			worksheet.getCell(`E${rowOffset}`).value = { formula: `SUM(E${headerOffset}:E${rowOffset - 1})` };
			worksheet.getCell(`F${rowOffset}`).value = { formula: `SUM(F${headerOffset}:F${rowOffset - 1})` };
			worksheet.getCell(`G${rowOffset}`).value = { formula: `SUM(G${headerOffset}:G${rowOffset - 1})` };
			
			
			this.setStylesForCells(worksheet, xlsxSalesStyles.totalStyles, rowOffset);

			workbook.xlsx
				.writeBuffer()
				.then((data) => {
					const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
					saveAs(blob, `Cashier_Sales_Report_${this.fileNameDateRange}.xlsx`);
				})
				.catch((e) => {
					console.error(e);
					this.status.message = `Error Saving xlsx file: ${e}`;
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 28px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider:before {
  position: absolute;
  content: "";
  height: 21px;
  width: 21px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: green;
}

input:focus + .slider {
  box-shadow: 0 0 1px green;
}

.all-statuses-switch {
	display: flex;
	margin-top: 5px;
	align-items: center;
	font-weight: bold;
	justify-content: center;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

</style>
